// import { createI18n } from 'vue-i18n'
// // 框架 国际化文件
// const zh_cn = import.meta.glob('./lang/**/zh-CN.ts', { eager: true })
// const en = import.meta.glob('./lang/**/en.ts', { eager: true })

// // 加载 lang文件夹下的国际化
// export const loadLang = (modules: Record<string, any>) => {
//   const message: { [key: string]: string } = {}

//   Object.keys(modules).forEach((module) => {
//     Object.assign(message, { ...modules[module].default })
//   })
//   return message
// }
// export const messages: { [key: string]: any } = {
//   'zh-CN': {
//     langName: '简体中文',
//     ...loadLang(zh_cn)
//   },
//   en: {
//     langName: 'English',
//     ...loadLang(en)
//   }
// }

// // 返回当前language
// function getLanguage() {
//   // 默认语言为英文
//   return localStorage.getItem('lang') || 'en'
// }

// export const i18n = createI18n({
//   locale: getLanguage(),
//   // 需要使用组合式api需要设置
//   legacy: false,
//   messages
// })
import { createI18n } from 'vue-i18n';
import en from './lang/en.json';
import zh from './lang/zh.json';

const messages = {
  en,
  zh,
};

const i18n = createI18n({
  locale: 'en', // 默认语言
  messages,
});

export default i18n;